import { AbilityContext } from 'components/Permissions/Can'
import features, { category } from 'keys/features'
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { assessmentRQ, ratingRQ, staticRQ, testTakerRQ, ticketRQ } from 'store/hooks'

const MainApp = React.memo(() => {
    const { defaultRole, roleIndex } = useSelector(state => state.user)

    // const testTakers = testTakerRQ.useGetTestTakersOptions()
    // const watingForMarkingCount = assessmentRQ.useWatingForMarkingCount()
    // const ticketCount = ticketRQ.useTicketCount()
    const languages = staticRQ.useGetLanguages()
    const ratings = ratingRQ.useGetRatings()
    const categories = staticRQ.useGetCategories()
    const batteries = staticRQ.useGetBatteries()
    const roles = staticRQ.useGetRoles()
    const cities = staticRQ.useGetCities()
    const users = staticRQ.useGetUsers()

    const ability = useContext(AbilityContext)

    const canReadCategories = ability.can('read', features.category)
    const canReadTestTaker = ability.can('read', features.test_taker)
    const canReadScoreMethod = ability.can('read', features.score_method)
    const canReadBatteries = ability.can('read', features.battery)

    useEffect(() => {
        if (defaultRole && typeof roleIndex == 'number') {
            // if (!ticketCount.data && !ticketCount.isLoading)
            //     ticketCount.refetch()

            if (!languages.data && !languages.isLoading)
                languages.refetch()

            if (!cities?.data && !cities.isLoading) 
                cities.refetch()

            if (!categories.data && !categories.isLoading && canReadCategories) {
                categories.refetch()
            }

            // if (!testTakers.data && !testTakers.isLoading && canReadTestTaker) {
            //     testTakers.refetch()
            // }
            if (!ratings.data && !ratings.isLoading && canReadScoreMethod)
                ratings.refetch()

            if (!batteries.data && !batteries.isLoading && canReadBatteries)
                batteries.refetch()

            if (ability.can("manage", "super-user")) {
                users.refetch()
            }

            if (ability.can("read", "user_role")) {
                if (!roles.data && !roles.isLoading)
                    roles.refetch()



                // if (!watingForMarkingCount.data && !watingForMarkingCount.isLoading)
                //     watingForMarkingCount.refetch()


                // if (!watingForMarkingCount.data && !watingForMarkingCount.isLoading)
                //     watingForMarkingCount.refetch()
            }
        }
    }, [defaultRole, roleIndex])

    return null
})


export default MainApp